import { client } from 'components/ApolloProvider'
import { CREATE_AI_DESCRIPTION_JOB } from './createAiDescriptionJob'
import { GET_CREATION_AI_DESCRIPTION_RESULT } from './getCreationAiDescriptionResult'
import * as Types from './types'

const aiDescriptionApi = {
  createAiDescriptionJob: (file: File): Promise<Types.CreateAiDescriptionJobFR> =>
    client.mutate({
      mutation: CREATE_AI_DESCRIPTION_JOB,
      variables: { file },
      errorPolicy: 'all',
    }),

  getCreationAiDescriptionResult: (
    fileAiDescriptionId: string
  ): Promise<Types.GetCreationAiDescriptionResultAQR> =>
    client.query({
      query: GET_CREATION_AI_DESCRIPTION_RESULT,
      variables: { fileAiDescriptionId },
    }),
}

export default aiDescriptionApi
